var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('helio-empty',{staticClass:"table__empty-table",attrs:{"initial-title":_vm.title,"illustration":"search"}})}
var staticRenderFns = []

export { render, staticRenderFns }